import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import AgencyRoute from "@/components/AgencyRoute";
import Layout from "@/components/Layout";
import Agenda from "@/pages/Agenda";
import AdminLayout from "@/components/AdminLayout";
import Landing from "@/pages/Landing";
import ComingSoon from "@/pages/ComingSoon";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SetPassword from "@/pages/SetPassword";
import AgencyRegister from "@/pages/AgencyRegister";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import Leads from "@/pages/Leads";
import Properties from "@/pages/Properties";
import SettingsPage from "@/pages/Settings";
import Support from "@/pages/Support";
import Onboarding from "@/pages/Onboarding";
import Agenciamento from "@/pages/Agenciamento";
import LegalAdvisor from "@/pages/LegalAdvisor";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsersList from "@/pages/admin/AdminUsersList";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminBroadcast from "@/pages/admin/AdminBroadcast";
import AdminAudit from "@/pages/admin/AdminAudit";
import AgencyLayout from "@/pages/agency/AgencyLayout";
import AgencyDashboard from "@/pages/agency/AgencyDashboard";
import AgencyLeads from "@/pages/agency/AgencyLeads";
import AgencyAgenciamentos from "@/pages/agency/AgencyAgenciamentos";
import AgencyPropertySearch from "@/pages/agency/AgencyPropertySearch";
import AgencyRealtors from "@/pages/agency/AgencyRealtors";
import AgencySettings from "@/pages/agency/AgencySettings";
import AgencyDistributeLeads from "@/pages/agency/AgencyDistributeLeads";
import { Toaster } from "sonner";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/landing-legado" element={<Landing />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/register" element={<Register />} />
          <Route path="/auth/set-password" element={<SetPassword />} />
          <Route path="/imobiliaria/register" element={<AgencyRegister />} />

          <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="chat" element={<Chat />} />
            <Route path="leads" element={<Leads />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="imoveis" element={<Properties />} />
            <Route path="agenciamento" element={<Agenciamento />} />
            <Route path="juridico" element={<LegalAdvisor />} />
            <Route path="config" element={<SettingsPage />} />
            <Route path="suporte" element={<Support />} />
            <Route path="onboarding" element={<Onboarding />} />
          </Route>

          <Route path="/imobiliaria" element={<AgencyRoute><AgencyLayout /></AgencyRoute>}>
            <Route index element={<AgencyDashboard />} />
            <Route path="leads" element={<AgencyLeads />} />
            <Route path="distribuir" element={<AgencyDistributeLeads />} />
            <Route path="agenciamentos" element={<AgencyAgenciamentos />} />
            <Route path="imoveis" element={<AgencyPropertySearch />} />
            <Route path="corretores" element={<AgencyRealtors />} />
            <Route path="config" element={<AgencySettings />} />
          </Route>

          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsersList />} />
            <Route path="users/:id" element={<AdminUserDetail />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="broadcast" element={<AdminBroadcast />} />
            <Route path="auditoria" element={<AdminAudit />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
